// document.addEventListener('DOMContentLoaded', function() {
//   var priceElement = document.querySelector('.price');
//   var precioNormal = '$650';
//   var precioEspecial = '$445';
//   var container = document.querySelector('.variant-option'); // <--- el contenedor padre fijo

//   if (!container) return;


//    if(window.location.href.includes('https://sepua.mx/products/room-spray')){
//        container.addEventListener('click', function(event) {
//     // Busca el botón clickeado con data-input-id
//     var button = event.target.closest('[data-input-id]');
//     if (!button) return;

//     // Cambia el precio según el botón
//     if (button.getAttribute('data-input-id') === '1-5') {
//       priceElement.textContent = precioEspecial;
//     } else {
//       priceElement.textContent = precioNormal;
//     }

//     // Opcional: Clase visual
//     var buttons = container.querySelectorAll('[data-input-id]');
//     buttons.forEach(function(b) { b.classList.remove('selected'); });
//     button.classList.add('selected');
//   });
//    }
  
// });


// cambios.js - Todo junto en el orden correcto



function escapeRegex(text) {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function replaceWithStrikethrough(root, searchText, replaceText) {
  const walker = document.createTreeWalker(
    root,
    NodeFilter.SHOW_TEXT,
    null
  );

  const nodesToReplace = [];
  let node;

  while ((node = walker.nextNode())) {
    // Verificar que ningún ancestro ya fue procesado
    let ancestor = node.parentNode;
    let alreadyReplaced = false;
    while (ancestor) {
      if (ancestor.dataset?.replaced === 'true') {
        alreadyReplaced = true;
        break;
      }
      ancestor = ancestor.parentNode;
    }

    if (!alreadyReplaced && node.textContent.includes(searchText)) {
      nodesToReplace.push(node);
    }
  }

  nodesToReplace.forEach(node => {
    const span = document.createElement('span');
    span.dataset.replaced = 'true';
    span.innerHTML = node.textContent.replace(
      new RegExp(escapeRegex(searchText), 'g'),
      `<span style="text-decoration: line-through; color: gray; margin-right: 6px;">${searchText}</span>` +
      `<span style="color: #c03d2b; font-weight: 400;">${replaceText}</span>`
    );
    node.parentNode.replaceChild(span, node);
  });
}

function waitAndReplace(searchText, replaceText, timeout = 5000) {
  const target = document.body || document.documentElement;
  if (!target) return;

  const start = Date.now();
  let isProcessing = false; // 🔒 Bandera para evitar ejecuciones simultáneas

  const observer = new MutationObserver(() => {
    if (isProcessing) return; // Si ya está corriendo, ignorar
    if (Date.now() - start > timeout) {
      observer.disconnect();
      return;
    }

    isProcessing = true;
    observer.disconnect();

    replaceWithStrikethrough(target, searchText, replaceText);

    // Pequeño delay antes de reconectar para evitar loops
    setTimeout(() => {
      isProcessing = false;
      if (Date.now() - start < timeout) {
        observer.observe(target, { childList: true, subtree: true });
      }
    }, 100);
  });

  observer.observe(target, { childList: true, subtree: true });
  replaceWithStrikethrough(target, searchText, replaceText);
}

document.addEventListener('DOMContentLoaded', () => {
  waitAndReplace("$ 900.00 MXN", "$ 801.00 MXN");
  waitAndReplace("$ 1,550.00 MXN", "$ 1,379.50 MXN");
});


fetch('/cart.js').then(r => r.json()).then(cart => {
  console.log('=== DESCUENTOS CARRITO ===', cart.cart_level_discount_applications);
  console.log('=== DESCUENTOS TOTALES ===', cart.discount_applications);
  cart.items.forEach(item => console.log({
    titulo: item.title,
    precio_original: item.original_price,
    precio_final: item.final_price,
    descuentos: item.discount_allocations
  }));
});

fetch('/cart.js').then(r => r.json()).then(cart => {
  console.log(JSON.stringify(cart, null, 2));
});